import React, { useEffect, useState} from 'react'
import { connect } from'react-redux'
import { getList } from '../../actions/reviews'
import Loader from 'react-loader'
import AddEditModal from './Components/AddEditModal'
import styles from './styles.module.scss'
import { NavLink } from 'react-router-dom'
import { FaRegMessage, FaRegStar, FaStar, FaStarHalfStroke } from "react-icons/fa6";
import { MdOutlineInsertPhoto } from "react-icons/md";
import { SearchInput } from '../../assets/FindField/FindField'
import { Pagination } from "../../assets/Pagination/Pagination";



const List = ({ getList, data, loading, isTeacher, pageCount }) => {
  
  const [modal, setModal] = useState(null)
  const [findString, setFindString] = useState('')
  const [pageNumber, setPageNumber] = useState(0)

  const renderStars = (score = 0, size = 30) => {
    const full = Math.floor(score);
    const hasHalf = score % 1 !== 0;
    const empty = 5 - full - (hasHalf ? 1 : 0);
  
    return (
      <>
        {Array.from({ length: full }).map((_, idx) => (
          <FaStar key={`full-${idx}`} size={size} color="#7b2b2a" />
        ))}
        {hasHalf && <FaStarHalfStroke key="half" size={size} color="#7b2b2a" />}
        {Array.from({ length: empty }).map((_, idx) => (
          <FaRegStar key={`empty-${idx}`} size={size} color="#7b2b2a" />
        ))}
      </>
    );
  };

  useEffect(() => {
    getList(findString, pageNumber)
  }, [findString, pageNumber])
  
  const renderRow = (item) => (
    <li key={item.mid}>
      <NavLink to={`/reviews/${item.mid}`}>
        <div>
          <MdOutlineInsertPhoto size={50} color='#7b2b2a' />
        </div>
        <div>
          <h5>{item.fio}</h5>
          <div>
          <div className={styles.rating}>
            {renderStars(item.average_score, 30)}
            <span>{item.average_score}</span>
            <div style={{margin: '0 10px 0 1rem', display: 'flex', alignItems: 'center'}}>
              <FaRegMessage size={20} color='#7b2b2a' />
              <span style={{marginLeft: '.5rem'}}>{item.count_reviews} отзывов</span>
            </div>
            </div>
          </div>

        </div>
      </NavLink>
    </li>
  )

  return (
    <div className={styles.listWrapper}>
      <div className="captions">Отзывы о преподавателях</div>
      <div>
        {!isTeacher && <button onClick={() => setModal({})} className="btn">Добавить отзыв</button>}
        <SearchInput onChange={setFindString} />
      </div>
      <AddEditModal
        isOpen={!!modal}
        onRequestClose={() => setModal(null)}
        data={modal}
        getListCB={() => getList(findString, pageNumber)}
      />
      <Loader loaded={!loading} color='grey'>
        <Pagination
          pageCount={pageCount}
          onPageChange={({selected}) => setPageNumber(selected)}
          numberPage={pageNumber}
        />
          <ul>{data?.map(renderRow)}</ul>
        <Pagination
          pageCount={pageCount}
          onPageChange={({selected}) => setPageNumber(selected)}
          numberPage={pageNumber}
        />
      </Loader>
    </div>
  )
}


const mapStateToProps=({auth, reviews})=>({
  data: reviews.list.data,
  pageCount: reviews.list.pageCount,
  loading: reviews.loading,
  isTeacher: auth.isTeacher
})


export default connect(mapStateToProps, {getList})(List)